import {createAction} from "@reduxjs/toolkit";
import * as types from "../constants/ActionTypes";

export const fetchDealers = createAction(types.FETCH_DEALERS);
export const fetchDealersSuccess = createAction(types.FETCH_DEALERS_SUCCESS);
export const fetchDealersFailure = createAction(types.FETCH_DEALERS_FAILURE);
